import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const fetchIndexSetTemplateDefaults = () => fetch("GET", qualifyUrl("/system/indices/index_sets/templates/default_config"));
const useIndexSetTemplateDefaults = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["index-templates-defaults"],
    queryFn: () => defaultOnError(fetchIndexSetTemplateDefaults(), "Error fetching index default template"),
    retry: 1
  });
  return {
    loadingIndexSetTemplateDefaults: isLoading,
    indexSetTemplateDefaults: data
  };
};
export default useIndexSetTemplateDefaults;
